<template>
  <div>
    <div class="mrB20" />
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_NODE_SELT')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-3">
          <sui-custom-select
            ref="selectBox"
            :selected="workflowNode"
            :option-list="optionList.nodeOptionList"
            :initialSelectedIndex="0"
            @loaded="onLoaded"
          />
          <!-- @list-clicked="nodeSelectChange" -->
        </div>
        <div class="col-xs-1 nodata" />
        <div class="col-xs-7" />
      </div>
    </div>
    <div class="mrB30" />
    <sui-grid
      ref="grid"
      :columns="gridColumns0"
      :dataset="'dsWorkflowNodeRelation'"
      :showDisplayCountControl="false"
      :multiselect="true"
    >
      <div class="comp_spacing" />
      <div class="btn_wrapL">
        <sui-button
          type="button"
          class="comm_btn_gridTop"
          @click="onClickRowAdd"
        >
          {{ $t('MSG_BTN_ROW_ADD') }}
        </sui-button>
        <sui-button
          v-permission:delete="pageId"
          type="button"
          class="comm_btn_gridTop"
          @click="onClickRowDelete"
        >
          {{ $t('MSG_BTN_ROW_DEL') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_gridTop"
          @click="onClickRowCancel"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
      </div>
    </sui-grid>
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:read="pageId"
        type="button"
        class="comm_btn_border"
        @click="onClickPreview"
      >
        {{ $t('MSG_BTN_PRVW') }}
      </sui-button>
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00001_T03', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    workflowId: {
      type: String,
      default: null,
    },
    relationRuleInfo: {
      type: Object,
      default: null,
    },
    paramMappingInfo: {
      type: Object,
      default: null,
    },
    selectedNodeInfo: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      workflowNode: { key: '', label: '' },
      optionList: {
        nodeOptionList: [{ key: '', label: '' }],
      },
      commonOptionList: {
        COD_RTL_NODE_TYPE: [],
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_RLT'),
        datafield: 'relationNodeTypeCode',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement,
            {
              optionList: this.commonOptionList.COD_RTL_NODE_TYPE,
            },
            this.dsWorkflowNodeRelation, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_NODE_ID'),
        datafield: 'relationNodeId',
      }, {
        text: this.$t('MSG_TXT_NODE_NM'),
        datafield: 'nodeName',
      }, {
        text: this.$t('MSG_TXT_RUL_NM'),
        datafield: 'ruleName',
      }, {
        text: this.$t('MSG_TXT_RUL_EDIT'),
        datafield: 'ruleButton',
        width: '80px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onClickRuleEdit,
            type: 'positive',
          }, this.dsWorkflowNodeRelation, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_PRMT_MAPPING'),
        datafield: 'paramButton',
        width: '80px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onClickParamEdit,
            type: 'positive',
          }, this.dsWorkflowNodeRelation, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
    };
  },
  computed: {},
  watch: {
    workflowId() {
      if (!utils.isEmpty(this.workflowId)) {
        this.setWorkflowNodeData();
      }
    },
    workflowNode: {
      deep: true,
      handler() {
        if (utils.isEmpty(this.workflowNode.key)) {
          this.dsWorkflowNodeRelation.submit();
          this.dsWorkflowNodeRelation.setRawData([]);
        } else {
          this.nodeSelectChange();
        }
      },
    },
    paramMappingInfo: {
      deep: true,
      handler() {
        if (!utils.isUndefined(this.paramMappingInfo)
         && !utils.isEmpty(this.paramMappingInfo)) {
          this.paramGridEdit();
        }
      },
    },
    relationRuleInfo: {
      deep: true,
      handler() {
        this.ruleGridEdit();
        // if (!utils.isUndefined(this.relationRuleInfo)
        //  && !utils.isEmpty(this.relationRuleInfo)) {
        //   this.ruleGridEdit();
        // }
      },
    },
    selectedNodeInfo: {
      deep: true,
      handler() {
        if (!utils.isUndefined(this.selectedNodeInfo)
         && !utils.isEmpty(this.selectedNodeInfo)) {
          this.gridRowAdd();
        }
      },
    },
  },
  mounted() {
    this.commCodeSelect();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * ROW '편집' BUTTON EVENT CALLBACK
     */
    onLoaded() {
      this.$refs.selectBox.reset();
    },
    /**
     * 노드 관계 selectBox OptionList 조회
     */
    commCodeSelect() {
      http.mergeCodeList(this.pageId, ['COD_RTL_NODE_TYPE'], this.commonOptionList).then(() => {
        if (!utils.isEmpty(this.workflowId)) {
          this.setWorkflowNodeData();
        }
      });
    },
    /**
     * 노드 선택 selectBox OptionList 조회
     */
    setWorkflowNodeData() {
      http.request(this.pageId, 'DTS_CMR_00029', {
        path: {
          'workflow-id': this.workflowId,
        },
        query: {
          nodeTypeCode: 'FN', // 노드상태 '종료' 노드를 제외하고 목록 조회
        },
      }).then(res => {
        this.optionList.nodeOptionList = [];
        const options = [];
        res.data.forEach(obj => {
          const option = {
            key: obj.workflowNodeUid,
            label: obj.nodeName,
            nodeId: obj.nodeId,
            pageId: obj.pageId,
            dataServiceId: obj.dataServiceId,
            moduleCode: obj.moduleCode,
            subModuleCode: obj.subModuleCode,
          };
          options.push(option);
        });
        if (utils.size(options) < 1) {
          options.push({ key: ' ', label: '' });
        }
        this.optionList.nodeOptionList = options;
        this.workflowNode.key = '';
      });
    },
    /**
     * 노드 선택 selectBox 변경 시 목록 재 조회
     */
    nodeSelectChange() {
      this.setWorkflowNodeRelationData();
    },
    /**
     * 노드 관게 목록 조회
     */
    setWorkflowNodeRelationData() {
      http.request(this.pageId, 'DTS_CMR_00032', {
        path: {
          'workflow-node-uid': this.workflowNode.key,
        },
      }).then(res => {
        const data = utils.clone(res.data);
        data.forEach((itm, index) => {
          data[index].paramButton = this.$t('MSG_BTN_EDIT');
          data[index].ruleButton = this.$t('MSG_BTN_EDIT');
        });
        this.dsWorkflowNodeRelation.submit();
        this.dsWorkflowNodeRelation.setRawData(data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * grid 룰 편집 Button Event
     * 관계 룰 등록 팝업 호출.
     */
    onClickRuleEdit(event, dataRow) {
      const workflowNodeInfo = utils.find(this.optionList.nodeOptionList,
        { key: dataRow.workflowNodeUid });
      const relationRuleInfo = {
        ruleUid: dataRow.relationRuleUid,
        ruleName: dataRow.ruleName,
        nodeName: dataRow.nodeName,
        moduleName: dataRow.moduleName,
        subModuleName: dataRow.subModuleName,
        pageId: dataRow.pageId,
        relationNodeId: dataRow.relationNodeId,
        dataServiceId: dataRow.dataServiceId,
        relationNodeTypeName: dataRow.relationNodeTypeName,
        workflowNodeInfo,
      };
      this.$emit('setPopupProp', 'setRelationRuleInfo', relationRuleInfo);
      this.$emit('popupCall', 'p05', 'grid', dataRow['dataset-row-id']);
    },
    /**
     * grid 룰 편집 callBack
     * 관계 룰 등록 팝업 callBack.
     */
    ruleGridEdit() {
      const rowIndex = utils.findIndex(this.dsWorkflowNodeRelation.data,
        o => utils.isEqual(o['dataset-row-id'], this.relationRuleInfo.rowId));

      this.dsWorkflowNodeRelation.setData(rowIndex, 'relationRuleUid', this.relationRuleInfo.ruleUid);
      this.dsWorkflowNodeRelation.setData(rowIndex, 'ruleName', this.relationRuleInfo.ruleName);
      this.dsWorkflowNodeRelation.setData(rowIndex, 'dataServiceId', this.relationRuleInfo.dataServiceId);
      this.dsWorkflowNodeRelation.setData(rowIndex, 'moduleName', this.relationRuleInfo.moduleName);
      this.dsWorkflowNodeRelation.setData(rowIndex, 'subModuleName', this.relationRuleInfo.subModuleName);
      this.dsWorkflowNodeRelation.setData(rowIndex, 'pageId', this.relationRuleInfo.pageId);
    },
    /**
     * grid 파라미터 매핑 Button Event
     * 파라미터 관리 팝업 호출.
     */
    onClickParamEdit(event, dataRow) {
      if (utils.isEmpty(dataRow.relationNodeTypeCode)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_ID'), this.$t('MSG_TXT_RLT')));
        return false;
      }

      const relationNodeTypeInfo = utils.find(this.commonOptionList.COD_RTL_NODE_TYPE,
        { key: dataRow.relationNodeTypeCode });
      const workflowNodeInfo = utils.find(this.optionList.nodeOptionList,
        { key: dataRow.workflowNodeUid });
      const dataServiceId = utils.isEmpty(dataRow.dataServiceId)
        ? workflowNodeInfo.dataServiceId
        : dataRow.dataServiceId;
      const paramMappingInfo = {
        nodeRelationUid: dataRow.nodeRelationUid,
        workflowId: this.workflowId,
        nodeId: dataRow.nodeId,
        ruleUid: dataRow.relationRuleUid,
        ruleName: dataRow.ruleName,
        nodeName: dataRow.nodeName,
        moduleName: dataRow.moduleName,
        subModuleName: dataRow.subModuleName,
        pageId: dataRow.pageId,
        relationNodeId: dataRow.relationNodeId,
        relationNodeTypeName: relationNodeTypeInfo.label,
        relationNodeTypeCode: relationNodeTypeInfo.key,
        saveWorkflowNodeRelationParamList: dataRow.saveWorkflowNodeRelationParamList,
        dataServiceId,
      };

      this.$emit('setPopupProp', 'setParamMappingInfo', paramMappingInfo);
      this.$emit('popupCall', 'p07', 'grid', dataRow['dataset-row-id']);

      return null;
    },
    /**
     * grid 파라미터 매핑 callBack
     * 파라미터 관리 팝업 callBack.
     */
    paramGridEdit() {
      const rowIndex = utils.findIndex(this.dsWorkflowNodeRelation.data,
        o => utils.isEqual(o['dataset-row-id'], this.paramMappingInfo.rowId));
      const paramSaveList = this.paramMappingInfo.saveWorkflowNodeRelationParamList;
      const paramDeleteList = this.paramMappingInfo.deleteWorkflowNodeRelationParamList;

      this.dsWorkflowNodeRelation.setData(rowIndex, 'saveWorkflowNodeRelationParamList', paramSaveList);
      this.dsWorkflowNodeRelation.setData(rowIndex, 'deleteWorkflowNodeRelationParamList', paramDeleteList);
    },
    /**
     * 저장
     */
    onClickSave() {
      const dataParams = this.rowState();

      utils.assign(dataParams, {
        workflowId: this.workflowId,
      });

      // if (!this.validationCheck()) return false;
      if (!this.selectedRowCheck()) return false;

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMR_00034', {
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));

          this.dsWorkflowNodeRelation.submit();

          this.setWorkflowNodeRelationData();
        });
      });

      return true;
    },
    rowState() {
      const insertWorkflowNodeRelationList = [];
      const updateWorkflowNodeRelationList = [];
      const deleteWorkflowNodeRelationList = [];

      utils.forEach(this.dsWorkflowNodeRelation.rowStateMap, (key, value) => {
        let index = -1;
        switch (key) {
          case 'D':
            index = utils.findIndex(this.dsWorkflowNodeRelation.originalData,
              o => utils.isEqual(o['dataset-row-id'], value));
            if (index > -1) deleteWorkflowNodeRelationList.push(this.dsWorkflowNodeRelation.originalData[index]);
            break;
          case 'U':
            index = utils.findIndex(this.dsWorkflowNodeRelation.data,
              o => utils.isEqual(o['dataset-row-id'], value));
            if (index > -1) updateWorkflowNodeRelationList.push(this.dsWorkflowNodeRelation.data[index]);
            break;
          case 'C':
            index = utils.findIndex(this.dsWorkflowNodeRelation.data,
              o => utils.isEqual(o['dataset-row-id'], value));
            if (index > -1) insertWorkflowNodeRelationList.push(this.dsWorkflowNodeRelation.data[index]);
            break;
          default:
            break;
        }
      });

      return {
        insertWorkflowNodeRelationList,
        updateWorkflowNodeRelationList,
        deleteWorkflowNodeRelationList,
      };
    },
    /**
     * 미리보기
     */
    onClickPreview() {
      this.$emit('popupCall', 'p02');
    },
    /**
     * 행 추가
     * 노드 선택 팝업 호출
     */
    onClickRowAdd() {
      const selectedNodeOption = utils.find(this.optionList.nodeOptionList, { key: this.workflowNode.key });
      this.$emit('setPopupProp', 'selectedNodeOption', selectedNodeOption);
      this.$emit('popupCall', 'p08');
    },
    /**
     * 행 추가
     * 노드 선택 팝업 callback
     */
    gridRowAdd() {
      const rows = [];
      const selectedNodeOption = utils.find(this.optionList.nodeOptionList, { key: this.workflowNode.key });

      utils.forEach(this.selectedNodeInfo, obj => {
        // const rowIndex = utils.findIndex(this.dsWorkflowNodeRelation.data,
        //   o => utils.isEqual(o.relationNodeId, obj.nodeId));
        const defaultRow = {
          workflowNodeUid: this.workflowNode.key,
          nodeId: selectedNodeOption.nodeId,
          relationNodeId: obj.nodeId,
          nodeName: obj.nodeName,
          workflowId: this.workflowId,
          paramButton: this.$t('MSG_BTN_EDIT'),
          ruleButton: this.$t('MSG_BTN_EDIT'),
        };
        rows.push(defaultRow);
        // if (rowIndex < 0) {
        //   rows.push(defaultRow);
        // }
      });
      this.dsWorkflowNodeRelation.addRows(rows);
    },
    /**
     * 행 삭제
     */
    onClickRowDelete() {
      const selectedIndexes = this.dsWorkflowNodeRelation.getSelectedIndexes();
      this.dsWorkflowNodeRelation.deleteRows(selectedIndexes);
    },
    /**
     * 취소
     */
    onClickRowCancel() {
      this.dsWorkflowNodeRelation.submit();
      this.dsWorkflowNodeRelation.setRawData(this.dsWorkflowNodeRelation.originalData);
    },
    selectedRowCheck() {
      if (utils.isEmpty(utils.trim(this.workflowId))) {
        utils.messageBox('warning', this.$t('MSG_ALT_WKFL_NOT_INFO'));
        return false;
      }
      return true;
    },
  },
  datasets: [{
    id: 'dsWorkflowNodeRelation',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'paramButton', map: 'paramButton' },
      { type: 'string', name: 'ruleButton', map: 'ruleButton' },
      { type: 'string', name: 'nodeRelationUid', map: 'nodeRelationUid' },
      { type: 'string', name: 'ruleName', map: 'ruleName' },
      { type: 'string', name: 'workflowNodeUid', map: 'workflowNodeUid' },
      { type: 'string', name: 'workflowId', map: 'workflowId' },
      { type: 'string', name: 'nodeId', map: 'nodeId' },
      { type: 'string', name: 'nodeName', map: 'nodeName' },
      { type: 'string', name: 'relationNodeTypeCode', map: 'relationNodeTypeCode' },
      { type: 'string', name: 'relationNodeTypeName', map: 'relationNodeTypeName' },
      { type: 'string', name: 'relationRuleUid', map: 'relationRuleUid' },
      { type: 'string', name: 'relationNodeId', map: 'relationNodeId' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'workflowNodeRelationParam', map: 'workflowNodeRelationParam' }],
  }],
};
</script>
<style scoped>
</style>
